import ApiService from "@/core/services/api.service";

// action types
export const LIST_USERS = "list_users";
export const ADD_USERS = "add_users";
export const CHANGE_PASS_USER = "change_pass_user";
export const CHANGE_USER_STATE = "change_user_status";
export const CHANGE_USER_ROLE = "change_user_roles";

// mutation types
export const SET_ERROR = "setErrorListUsers";

const actions = {
    [LIST_USERS](context) {
        return new Promise(resolve => {
            ApiService.post("show_users", {})
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [ADD_USERS](context, params) {
        return new Promise(resolve => {
            ApiService.post("add_user", params)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [CHANGE_PASS_USER](context, params) {
        return new Promise(resolve => {
            ApiService.post("change_password", params)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [CHANGE_USER_STATE](context, params) {
        return new Promise(resolve => {
            ApiService.post("change_user_status", params)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [CHANGE_USER_ROLE](context, params) {
        return new Promise(resolve => {
            ApiService.post("change_user_roles", params)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    }
};

export default {
    actions
};
